module.exports = __webpack_public_path__ + "static/media/time.3191a7e2.svg";